// extracted by mini-css-extract-plugin
export default {"button":"AdjustmentRemove-module--button--7dca9"};